import { createApp } from "vue";
import { createI18n } from "vue-i18n";

import store from "./store";
import App from "./App.vue";
//import router from "./router";
import messages from "./i18n/messages";

const i18n = createI18n({
    locale: "fr",
    fallbackLocale: "en",
    messages,
});

createApp(App, { page: "harkhan" }).use(i18n).use(store).mount("#app");

